import FormControl from '@mui/material/FormControl';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import React, {useState, useEffect} from 'react';
import {useTranslation} from "react-i18next";
import Toolbar from '@mui/material/Toolbar';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Grid from '@mui/material/Grid';
import {useGlobalStorage} from './mobx/GlobalStorage.js';
import metadata from './metadata.json';
import {COMM_OK} from './WsR2.js';

function AboutDialog() {
	const gStorage = useGlobalStorage();
	const {t} = useTranslation('obs');
	const [stats, setStats] = useState({
		observations: null,
		taxons: null,
		users: null
	});

	function aboutRxWs(status, obj) {
		if (status !== COMM_OK) {
			console.error('aboutRxWs: error ', status);
			return -1;
		}

		if (obj.cmd === 'info' && obj.op === 'stats') {
			if (obj.result === 'OK') {
// 				console.log('aboutRxWs:', obj);
				setStats(obj.data);
			} else {
				console.error('aboutRxWs: stats query failed! Result: ', obj.result);
			}
		} else {
			console.error('aboutRxWs: unknown command', obj.cmd, obj.op, obj.result);
		}
	}

	const loadStats = () => {
		let msg = {
			sess_id: gStorage.conn.sess_id,
			cmd: 'info',
			op: 'stats',
			data: {
			},
		}

		gStorage.conn.ws.send(msg, aboutRxWs);
	}

	useEffect(() => {
		if (gStorage.conn.online)
		    loadStats();

		// eslint-disable-next-line
	}, []);

	const handleClose = () => { 
		window.history.back();
	}

	const serverVersionStr = () => {
		if (gStorage.srv.info.server_version === undefined) {
			return '--';
		}

		return gStorage.srv.info.server_version + ', ' + gStorage.srv.info.build_date;
	}

	return (
        	<Dialog onClose={handleClose} aria-labelledby="simple-dialog-title" open={true} PaperProps={{sx: {margin: 0, padding: 0}}}>
			<Grid container direction="row" justifyContent="center" alignItems="center" spacing={0} style={{width:300}}>
				<AppBar position="sticky">
					<Toolbar variant="dense">
						<Typography variant="h6" style={{flexGrow: 1, textAlign: 'center'}}>{t('menu.about')}</Typography>
						<IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
							<CloseIcon />
						</IconButton>
					</Toolbar>
				</AppBar>
				<Grid size={{xs: 12}} align={'center'} style={{width:300}}>
					<FormControl variant="outlined" size="small" style={{width:300}} >
						<Typography variant='h6' align='center'>
							{t('about.versions')}
						</Typography>
						<div>{t('about.version')} : {metadata.build}, {metadata.date} {metadata.time}</div>
						<div>{t('about.server_version')} : {serverVersionStr()}</div>
						<div>&nbsp;</div>
						<Typography variant='h6' align='center'>
							{t('about.system')}
						</Typography>
						<div>{t('about.observations')} : {stats.observations !== null ? stats.observations : '-'}</div>
						<div>{t('about.users')} : {stats.users !== null ? stats.users : '-'}</div>
						<div>&nbsp;</div>
						<Typography variant='h6' align='center'>
							{t('about.open_source')}
						</Typography>
						<div>Maanmittauslaitos-Nimistö</div>
						<div>Ilmatieteenlaitos-Säähavainnot</div>
						<div>Lintuatlas 3-Pesimälajit</div>
						<div>&nbsp;</div>
						<div>Helsingin Seudun Lintutieteellinen Yhdistys Tringa ry (2021) Hangon lintuaseman aineisto: päiväsummat (versio 1.5). Ladattu osoitteesta <a href="http://www.halias.fi/pitkaaikaisaineisto">www.halias.fi/pitkaaikaisaineisto</a> 4.8.2022</div>
						<div>&nbsp;</div>
					</FormControl>
				</Grid>
			</Grid>
		</Dialog>
	);
}

export default AboutDialog;
